import React from "react";
import MedalIcon from "./MedalIcon";
import { formatCurrency } from "../utils/format";

// De drie vakjes onderaan kolom 2.

const KpiBox = ({ label, value, note }) => (
  <div className="kpi-box">
    <div className="k">{label}</div>
    <div className="v">{value}</div>
    <div className="m">{note}</div>
  </div>
);

// "12 deals · gem. €340"
const dealsNote = (deals) =>
  `${deals.totalDeals || 0} deals · gem. €${formatCurrency(deals.averagePrice)}`;

const KpiStrip = ({ bestSeller, previousMonth, deals, existantDeals }) => (
  <div className="kpi-strip">
    <KpiBox
      label="Beste verkoper"
      value={
        <>
          {bestSeller.name || "-"}
          {bestSeller.name && (
            <span className="medal-icon">
              <MedalIcon />
            </span>
          )}
        </>
      }
      note={`in ${previousMonth}`}
    />

    <KpiBox
      label="Totaal vorige maand"
      value={`€${formatCurrency(deals.totalPrice)}`}
      note={dealsNote(deals)}
    />

    <KpiBox
      label="Totaal bestaande deals"
      value={`€${formatCurrency(existantDeals.totalPrice)}`}
      note={dealsNote(existantDeals)}
    />
  </div>
);

export default KpiStrip;
